import React, { useContext } from 'react'
import styled from 'styled-components'

import TextButton from 'components/Luxkit/Button/TextButton'
import { mediaQueryDown, mediaQueryOnly } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { BOOKING_DETAILS_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import LEBookingTag from 'tripPlanner/Tripkit/Common/LEBookingTag'

const BookingDetailsContainer = styled(Group)`
  ${mediaQueryDown.mobile} {
    > * {
      flex-grow: 1;
    }
  }

  ${mediaQueryOnly.desktop} {
    > * {
      flex-grow: 1;
    }
  }
`

export default function BookingDetailsButtonAndTagView() {
  const tripContext = useContext(TripContext)
  const canEdit = tripContext?.permissions.canEdit ?? false
  const viewAsTemplate = tripContext?.viewAsTemplate ?? false

  if (!canEdit || viewAsTemplate) return null

  return (
    <BookingDetailsContainer
      direction="vertical"
      tabletDirection="horizontal"
      gap={12}
      horizontalAlign="space-between"
    >
      <LEBookingTag />
      <TextButton kind="secondary" nonInteractable>
        {BOOKING_DETAILS_COPY}
      </TextButton>
    </BookingDetailsContainer>
  )
}
